import { PlanId } from '__generated__/GQL';

type LegacyPlans = PlanId.Basic | PlanId.Plus | PlanId.Pro | PlanId.Business;

export const isLegacyPlan = (plan: PlanId): plan is LegacyPlans =>
  [PlanId.Basic, PlanId.Plus, PlanId.Pro, PlanId.Business].includes(plan);
